import { createSharedState } from '@play-co/replicant';
import { teamSharedStateSchema } from './team.schema';
import { teamMessages } from './team.messages';
import { teamComputedProperties } from './team.properties';

export const teamSharedState = createSharedState(
  teamSharedStateSchema,
  teamMessages,
  teamComputedProperties,
);
